import { userEventsPostPendingModalShown } from '../../../actions/user-events';

export const postPendingApprovalModalDataLoader = userEventsPostPendingModalShown;
